import React from "react";
import { useHistory } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";

import Button from "../../material-dashboard/components/CustomButtons/Button.jsx";
import Card from "../../material-dashboard/components/Card/Card.jsx";
import CardBody from "../../material-dashboard/components/Card/CardBody.jsx";
import GridContainer from "../../material-dashboard/components/Grid/GridContainer.jsx";
import GridItem from "../../material-dashboard/components/Grid/GridItem.jsx";

import consultationStyles from "../styles/consultationStyles";
import { kickBlue } from "../../shared/styles/baseStyles.js";

import imgSleepCoaching from "../../../../images/personalized-sleep-coaching-icon.svg";
import imgBiWeekly from "../../../../images/bi-weekly.svg";
import imgAtHome from "../../../../images/at-home.svg";
import imgDoctorReply from "../../../../images/doctor-reply-icon.svg";
import imgTrialPrescriptionIcon from "../../../../images/trial-prescription-icon.svg";
import imgExpertMedicalGuidance from "../../../../images/expert-medical-guidance.svg";

const liStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: "24px",
};

const iconStyle = {
  marginRight: "16px",
  height: "22px",
};

const v2Icon = {
  height: "150px",
  width: "150px",
};

const SleepMembershipDescriptionV1 = ({ classes, match }) => {
  const history = useHistory();

  return (
    <div className={classes.container} style={{ backgroundColor: "#3F3F82" }}>
      <GridContainer justifyContent="center">
        <GridItem xs={10} sm={10} md={8}>
          <h3
            style={{
              color: "#FFFFFF",
              fontFamily: "Spectral-SemiBold",
              fontSize: "32px",
              marginTop: "40px",
            }}
          >
            More Than Medication...
          </h3>
        </GridItem>
        <GridItem xs={12} sm={12} md={8}>
          <Card className={classes.cardConsultation}>
            <CardBody
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0 2px",
              }}
            >
              <div
                style={{
                  margin: "10px auto",
                  padding: "40px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <h3
                  style={{
                    textAlign: "center",
                    margin: "0",
                  }}
                >
                  Your membership includes:
                </h3>

                <ul
                  style={{
                    minWidth: "330px",
                    margin: "16px 0 10px 0",
                    position: "relative",
                    left: "-21px",
                    listStyle: "none",
                    fontSize: "16px",
                  }}
                >
                  <li style={liStyle}>
                    <img
                      src={imgBiWeekly}
                      className="icon"
                      alt=""
                      loading="lazy"
                      style={iconStyle}
                    />
                    Unlimited same-day follow-up appointments and prescription
                    medication
                  </li>
                  <li style={liStyle}>
                    <img
                      src={imgAtHome}
                      className="icon"
                      alt=""
                      loading="lazy"
                      style={iconStyle}
                    />
                    Use your HSA/FSA account for discounts on sleep-related
                    products gym membership, yoga classes, supplements, pillows
                    and other sleep equipment
                  </li>
                  <li style={liStyle}>
                    <img
                      src={imgDoctorReply}
                      className="icon"
                      alt=""
                      loading="lazy"
                      style={iconStyle}
                    />
                    AI text message assistant that helps you with healthy sleep
                    habits and reduces bedtime procrastination
                  </li>
                </ul>
              </div>
            </CardBody>
          </Card>
          <Button
            onClick={() => {
              const visitType = match.params.consultationType;
              history.push(`/visits/${visitType}/payment`);
            }}
            style={{
              display: "block",
              backgroundColor: "#F25930",
              margin: "30px auto",
              width: "300px",
              fontSize: "18px",
              fontWeight: "medium",
              textTransform: "unset",
            }}
          >
            Continue
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
};

const SleepMembershipDescriptionV2 = ({ classes, match }) => {
  const history = useHistory();

  return (
    <div
      className={`${classes.container} sleep-membership-description`}
      style={{ backgroundColor: "#3F3F82" }}
    >
      <GridContainer justifyContent="center">
        <GridItem xs={10} sm={10} md={9}>
          <h3
            style={{
              color: "#FFFFFF",
              fontFamily: "Spectral-SemiBold",
              fontSize: "32px",
              marginTop: "40px",
            }}
          >
            12-Week Stanford MD Sleep Program
          </h3>
          <p
            style={{
              color: "#FFFFFF",
              fontFamily: "BasisGrotesquePro-Regular",
              fontSize: "18px",
              lineHeight: "26px",
              textAlign: "left",
              // letterSpacing: "-0.21px"
            }}
          >
            No long wait times for a specialist, Unlimited sleep medication
            dosing trials, HSA/FSA discounts, and more...
          </p>
        </GridItem>
        <GridItem xs={12} sm={12} md={9}>
          <Card className={classes.cardConsultation}>
            <CardBody
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0 2px",
              }}
            >
              <div
                className="desc-container"
                style={
                  {
                    // color: kickBlue,
                  }
                }
              >
                <h3
                  style={{
                    textAlign: "center",
                    margin: "0",
                    // border: "1px solid yellow"
                  }}
                >
                  Your 12-week sleep plan includes:
                </h3>

                <div className="sleep-membership-item-container">
                  <div className="desc-item">
                    <img
                      style={{ ...v2Icon, position: "relative", top: "-30px" }}
                      className="img-trial-prescriptions"
                      src={imgTrialPrescriptionIcon}
                      alt="Trial Prescriptions"
                      loading="lazy"
                    />
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      The Best Sleep Medication For You
                    </p>

                    <p>
                      Over 12 weeks, try different doses of meds chosen by
                      Kick's sleep experts, such as: Hydroxyzine, Ramelteon,
                      Trazodone, and Cyclobenzaprine
                    </p>
                  </div>
                  <div className="desc-item">
                    <img
                      style={{ ...v2Icon, position: "relative", left: "26px" }}
                      src={imgExpertMedicalGuidance}
                      alt="Expert Medical Guidance"
                      loading="lazy"
                    />
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      Doctors Notes For Deep Discounts
                    </p>

                    <p>
                      Save up to 37% on gym memberships, yoga classes,
                      supplements, pillows, and more by using our customized
                      doctor notes with an HSA or FSA account
                    </p>
                  </div>
                  <div className="desc-item">
                    <img
                      style={{
                        ...v2Icon,
                        position: "relative",
                        top: "9px",
                        left: "-14px",
                      }}
                      src={imgSleepCoaching}
                      alt="Personalized Sleep Coaching"
                      loading="lazy"
                    />
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      Healthy Habits Sleep Coaching
                    </p>

                    <p>
                      Your personal sleep coach provides the support and
                      accountability needed to build better sleep habits and
                      reduce bedtime procrastination
                    </p>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Button
            onClick={() => {
              const visitType = match.params.consultationType;
              history.push(`/visits/${visitType}/select-pharmacy`);
            }}
            style={{
              display: "block",
              backgroundColor: "#F25930",
              margin: "30px auto",
              width: "300px",
              fontSize: "18px",
              fontWeight: "medium",
              textTransform: "unset",
            }}
          >
            Continue
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(consultationStyles)(SleepMembershipDescriptionV2);
